module.exports = __webpack_public_path__ + "img/two.4d4a284c.png";